import ChatPage from "../../pages/ChatPage";

export default {
  common: {
    enable: "Enable",
    notNow: "Not now",
    back: "Back",
    cancel: "Cancel",
    loading: "Loading",
    run: "Run all tasks",
  },
  registerScreen: {
    title: "Run Your Store\nSmarter, Cheaper,\nand 100x Faster—",
    subtitle: "with AI That Thinks Ahead",
    description:
      "Zeqi is your AI-powered strategist, operator, and planner—cutting 90% of your ecom costs while scaling your store with precision.",
    emailPlaceholder: "Enter your email",
    passwordPlaceholder: "Create a password",
    createAccount: "Create Account",
    alreadyHaveAccount: "Already have an account?",
    login: "Log In",
    signUpGoogle: "Sign Up with Google",
    signUpApple: "Sign Up with Apple",
    signUpPhone: "Sign Up with Phone Number",
    verifyContinue: "Verify & Continue",
  },
  loginScreen: {
    title: "Welcome Back to Zeqi",
    subtitle: "Your AI Partner for Smarter Ecom Growth",
    description:
      "Sign in below to continue building your store with AI that cuts costs, boosts sales, and never sleeps.",
    email: "Email",
    password: "Password",
    login: "Log In",
    newTo: "New to Zeqi?",
    createAccount: "Create an Account",
    inviteEmailRequired: "Please enter your invite email.",
    unauthorizedEmail: "Unauthorized email.",
  },
  shopifyConnectScreen: {
    heroTitle: "AI e-commerce \noperating system",
    connectCtaSubtitle: "Connect and ",
    connectCtaSubtitleBold: "let’s get started.",
    inviteLabel: "Email",
    invitePlaceholder: "you@company.com",
    continueWithShopify: "Continue With Shopify",
    continueWithWooCommerce: "Continue With WooCommerce",
    currentlySupporting: "Currently Supporting ",
    shopDomainPlaceholder: "yourstore.myshopify.com",
    termsBlurbPrefix: "By continuing, you agree to our ",
    termsLink: "Terms & Conditions",
    termsBlurbSuffix: ".",
  },

  SettingsScreen: {
    goBack: "Go Back",
    profileFallbackName: "Shop Name",
    profileFallbackEmail: "user@email.com",

    account: "Account",
    accountSettings: "Account Settings",
    connectedShop: "Connected Shop",
    notifications: "Notification Settings",
    securityLogin: "Security & Login",

    connectFacebook: "Connect Meta",
    connectGoogle: "Connect Google",
    facebookConnected: "Meta Successfully Connected",
    googleConnected: "Google Successfully Connected",
    socialAccounts: "Social Accounts",
    notificationsErrorTitle: "Update failed",
    notificationsErrorMessage:
      "We couldn't update your notification preference. Please try again.",
    authRequiredTitle: "Sign in required",
    authRequiredMsg: "Please sign in to manage your notification preferences.",
    notificationsOn: "Notifications On",
    notificationsOff: "Notifications Off",
    notificationsHint:
      "Receive alerts about tasks, reports, and account updates.",

    soon: "Soon",
    deleteAccount: "Delete Account",
    deleteAccountConfirmTitle: "Delete your account?",
    deleteAccountConfirmBody:
      "This will permanently remove your Zeqi account and sign you out. This action cannot be undone.",
    deleteAccountConfirmCta: "Delete account",
    deletingAccount: "Deleting...",
    deleteAccountFailed:
      "Unable to delete your account right now. Please try again.",
    signOut: "Sign Out",
    signOutHint: "Sign out of your account and return to the login page.",

    ai: "AI",
    aiSettings: "AI Settings",
    strategyProfile: "Strategy Profile",
    dataConsumption: "Data Consumption",

    billing: "Billing",
    subscriptions: "Subscriptions",
    billingPlan: "Billing Plan",
    paymentHistory: "Payment History",
    statusLabel: "Status",

    supportFeedback: "Support & Feedback",
    contactSupport: "Contact Support",
    helpCenter: "Help Center",
    reportBug: "Report A Bug",
    requestFeature: "Request a Feature",
    requestIntegration: "Request Integration",

    adminPromptManager: "Admin Prompt Manager",
    language: "Language",

    currentSubscription: "Current Subscription:",
    currentBillingPlan: "Current Billing Plan:",
    weekly: "Weekly",
    monthly: "Monthly",
    annual: "Annual",
    noTransactions: "No transaction history available.",
    unknown: "Unknown",

    planFree: "Free",
    planGeneral: "General",
    planPremium: "Premium",
    planSmsa: "SMSA",
    updateSubscription: "Update Subscription",
    refresh: "Refresh",

    legal: "Legal",
    terms: "Terms & Conditions",
    privacy: "Privacy Policy",
    deleteMyData: "Delete My Data",
    termsSummary: "Read our Terms & Conditions.",
    privacySummary: "Learn how we collect and use data.",
    deleteDataSummary:
      "Request deletion of your data or learn how data removal works.",
    openLink: "Open Link",
  },

  NotificationScreen: {
    title: "Notifications",
    markAll: "Mark all as read",
    empty: "No notifications yet.",
    authRequired: "Sign in to view notifications.",
  },

  HomeScreen: {
    notificationsPrompt:
      "Would you like Zeqi to send you notifications about reports, tasks, and important account updates?",
    notificationsDeclined:
      "You can enable notifications later from Settings whenever you're ready.",
  },

  OnboardingCostsModal: {
    title: "Action needed",
    body: "Before we move to the next stage, add product costs and operating costs so Zeqi can finish your assessment.",
    productCosts: "Product Costs",
    operatingCosts: "Operating Costs",
    dismiss: "Dismiss",
  },

  HeaderSection: {
    searchPlaceholder: "What's on your mind? Talk to me",
  },
  DrawerSection: {
    contactSupport: "Contact Support",
    helpCenter: "Help Center",
    reportBug: "Report A Bug",
    requestFeature: "Request a Feature",
    requestIntegration: "Request Integration",
    shopReports: "Shop Reports",
    productCosts: "Product Costs",
    operatingCosts: "Operating Costs",
    integrations: "Integrations",
  },
  HelpCenterScreen: {
    title: "Zeqi Help Center",
    faqTitle: "Frequently Asked Questions",
    moreHelpTitle: "Need More Help?",
    messageSupport: "Message Support",
    noticeText:
      "Free users have limited access. Upgrade to unlock premium features.",
    faqs: {
      upgradeSubscription: {
        question: "How do I upgrade my subscription?",
        answer:
          "Open Subscription from Settings, then enter your code or select a plan to upgrade.",
      },
      cancelSubscription: {
        question: "Can I cancel my subscription?",
        answer:
          "Yes. Go to Subscription → Manage → Cancel. Your access continues until the end of the billing period.",
      },
      applyPromoCode: {
        question: "How do I apply a promo/activation code?",
        answer:
          "In Subscription, paste your code (e.g., ZEQI-PREM-XXXX) and tap Apply.",
      },
      resetPassword: {
        question: "How do I reset my password?",
        answer:
          "On the login screen, tap ‘Forgot Password’ and follow the email instructions.",
      },
      multiDeviceUse: {
        question: "Can I use Zeqi on multiple devices?",
        answer: "Yes. Log in with the same account on each device.",
      },
      reportsRefresh: {
        question: "My reports didn’t refresh—what should I do?",
        answer:
          "Pull down to refresh on the Reports screen. If it persists, message support with the shop domain and a brief description.",
      },
      dataRefreshCadence: {
        question: "How often does Zeqi refresh data?",
        answer:
          "Free: limited previews. General: refresh on demand. Premium: priority refresh cadence.",
      },
      reportBugFeature: {
        question: "How do I report a bug or request a feature?",
        answer:
          "From the header menu, choose Report a Bug or Request a Feature, describe the issue/idea, and send.",
      },
      dataStorage: {
        question: "Does Zeqi store my data?",
        answer:
          "We store only what’s needed to operate your workspace and features. See our privacy policy for details.",
      },
      voiceInput: {
        question: "Voice input isn’t working.",
        answer:
          "Ensure microphone permissions are granted in your device settings, then try again.",
      },
      notifications: {
        question: "I’m not receiving notifications.",
        answer:
          "Enable notifications for Zeqi in system settings and inside Zeqi’s Notification preferences.",
      },
    },
  },

  GreetingSection: {
    greeting: "Hello {{name}} 🤚🏼,",
    fallbackName: "Partner",
    subtitle: "Your store is doing\nbetter than the way\nyou started", // default/fallback

    subtitleBands: {
      "0_1":
        "{{name}}, you’ve just connected Zeqi. Start by reading your Assessment Report",
      "1_10":
        "Nice start {{name}}. Keep reading your Assessment Report to warm up.",
      "10_20": "Nice lift off. Early wins compound.",
      "20_30": "Momentum building. Keep shipping.",
      "30_40": "You’re getting traction. Stay consistent.",
      "40_50": "Halfway in sight. Smart tweaks equal big gains.",
      "50_60": "Over the hump. Let’s push a little harder.",
      "60_70": "Strong flow. Optimize what is working.",
      "70_80": "You’re close. Tighten pricing and SEO.",
      "80_90": "Almost there. Execute the finishing touches.",
      "90_100": "Fantastic. You’re in the final stretch ({{percent}}%).",
    },

    subtitleClusters: {
      default: {
        "0_1":
          "{{name}}, you’ve just connected Zeqi. Start by reading your Assessment Report.",
        "1_10":
          "Nice start {{name}}. Keep reading your Assessment Report to warm up.",
        "10_20": "Nice lift off. Early wins compound.",
        "20_30": "Momentum building. Keep shipping.",
        "30_40": "You’re getting traction. Stay consistent.",
        "40_50": "Halfway in sight. Smart tweaks equal big gains.",
        "50_60": "Over the hump. Let’s push a little harder.",
        "60_70": "Strong flow. Optimize what is working.",
        "70_80": "You’re close. Tighten pricing and SEO.",
        "80_90": "Almost there. Execute the finishing touches.",
        "90_100": "Fantastic. You’re in the final stretch ({{percent}}%).",
      },

      onboarding: {
        "0_1":
          "Welcome to Zeqi {{name}}. Head to Execution Tab and connect Google (GA4, Search Console, Merchant Center) plus Meta (business, ads, pixel, IG).",
        "1_10":
          "Great start {{name}}. Keep connecting Google and Meta so Zeqi can see the full picture.",
        "10_20":
          "Nice lift off {{name}}. Keep credentials and data sources clean.",
        "20_30":
          "Momentum building. Double check the essentials stay synced at {{percent}}%.",
        "30_40": "You’re getting traction. Stay consistent with QA {{name}}.",
        "40_50":
          "Halfway there. Smart tweaks now mean smoother automations later.",
        "50_60":
          "Over the hump. Give the setup a gentle push toward {{percent}}%.",
        "60_70": "Strong flow. Keep leadership aligned on access {{name}}.",
        "70_80":
          "Almost wrapped. Document those final notes before {{percent}}% rolls over.",
        "80_90": "Only QA and approvals left. Button up onboarding {{name}}.",
        "90_100": "Onboarding done. Time for Foundation Stage ({{percent}}%).",
      },

      foundation_stage: {
        "0_1": "Welcome to Foundational and Business Reality Analysis Stage.",
        "1_10":
          "Foundation Stage is underway, {{name}}. Your assessment will update as signals come in.",
        "10_20":
          "Baseline is forming, {{name}}. We’ll surface key assessment insights soon.",
        "20_30":
          "Foundation progress is building. Assessment details will refine at {{percent}}%.",
        "30_40": "Good movement, {{name}}. The assessment is taking shape.",
        "40_50":
          "Halfway through the foundation snapshot. Assessment clarity improves next.",
        "50_60":
          "More signal coming in. Assessment is refining toward {{percent}}%.",
        "60_70":
          "Steady foundation momentum, {{name}}. Assessment insights are stabilizing.",
        "70_80":
          "Nearly there. Assessment highlights will be ready before {{percent}}%.",
        "80_90":
          "Almost complete. Final assessment checks are underway, {{name}}.",
        "90_100":
          "Foundation snapshot complete. Assessment is ready at {{percent}}%.",
      },

      top_of_funnel: {
        "0_1":
          "Strong work {{name}}. Welcome to your new Strategy Top of Funnel. Align the story before you amplify.",
        "1_10":
          "Nice early signals {{name}}. Keep aligning the story before you crank up reach.",
        "10_20": "Rise steady. Keep the content faucet on.",
        "20_30": "Momentum is real. Stay loud and present.",
        "30_40": "People are noticing. Keep feathering the throttle.",
        "40_50": "Halfway there. Smart creative swaps pay off.",
        "50_60": "Awareness compounding. Keep energy high.",
        "60_70": "Great flow. Amplify the winners.",
        "70_80": "Upper funnel feels sturdy. Stay balanced.",
        "80_90": "Only polish remains. CTA and copy tweaks.",
        "90_100":
          "Signal maxed. Toss the baton to Middle Funnel ({{percent}}%).",
      },

      middle_of_funnel: {
        "0_1":
          "You’re now in Middle Funnel {{name}}. Set the tone for how prospects experience proof.",
        "1_10":
          "Early days in Middle Funnel {{name}}. Start layering guides, comparators, and social proof.",
        "10_20": "Good lift off {{name}}. Layer guides and comparators.",
        "20_30": "Momentum building. Keep the stories flowing at {{percent}}%.",
        "30_40": "Prospects are leaning in. Stay consistent {{name}}.",
        "40_50": "Halfway there. Smart proof drops shift consideration.",
        "50_60":
          "Retargeting and nurture humming. Push a little harder toward {{percent}}%.",
        "60_70": "Strong cadence. Sharpen lead scoring and alerts {{name}}.",
        "70_80":
          "Almost nurture complete. Prime the bottom funnel for {{percent}}%.",
        "80_90": "Last tweaks before hand off. Keep it smooth {{name}}.",
        "90_100":
          "Mid funnel warm. Time to drive buying intent ({{percent}}%).",
      },

      bottom_of_funnel: {
        "0_1":
          "Bottom Funnel is engaged {{name}}. Start by making checkout feel rock solid.",
        "1_10":
          "Good opening move {{name}}. Begin testing offers and making checkout feel even smoother.",
        "10_20": "Good start {{name}}. Keep experimenting with offers.",
        "20_30":
          "Momentum showing. Stay on top of abandoned carts around {{percent}}% progress.",
        "30_40": "Buyers are close. Keep incentives sharp {{name}}.",
        "40_50": "Halfway there. Support plus FAQs remove the last friction.",
        "50_60":
          "Reviews and urgency doing work. Give it a little more to reach {{percent}}%.",
        "60_70": "Conversion engine stable. Optimize upsells {{name}}.",
        "70_80":
          "Almost there. Stress test operations and CX before {{percent}}%.",
        "80_90": "Only CRO polish left. You’ve got this {{name}}.",
        "90_100": "Checkout dialed. Go win more budget ({{percent}}%).",
      },
    },
  },
  ProfileSection: {
    title: "Your Current Key Focus Areas",
    loading: "Loading focus areas…",
    loadError: "Couldn’t load focus areas.",
    retry: "Retry",
    empty: "No focus areas yet.",

    modalTitle: "Full {{focusArea}}",
    modalFallbackTitle: "Focus Area",
    modalSubtitle: "Your current Key Focus Areas",
    modalNoData: "No data for this focus area yet.",

    untitledTask: "Untitled Task",
    short: "Short:",
    description: "Description:",
    dept: "Dept:",
    assigned: "Assigned:",
    noTasks: "No tasks yet.",
  },
  StrategyReportSection: {
    loading: "Loading strategy…",
    loadError: "Failed to load strategy.",
    retry: "Retry",

    assessmentTitle: "Assessment Report",
    assessmentPreviewFallback:
      "We’re reviewing your store’s current signals to generate an assessment.",
    assessmentButton: "Full Report",

    strategyTitle: "Strategy Proposal",
    strategyPreviewFallback:
      "Your strategy proposal will appear here once generated.",
    strategyButton: "Full Proposal",

    discuss: "Discuss",
    progressLabel: "{{percent}}%",
    modalTitle: "Full {{title}}",
    modalSubtitleFallback: "Profit Before Scale",

    cluster: "Cluster:",
    recommended: "Recommended:",
    research: "Research:",
    summary: "Summary:",
    description: "Description:",
    noExtra: "No additional report content yet.",
    emptyTitleCompleted: "Great work!",
    emptyBodyCompleted:
      "You’ve wrapped this strategy. Zeqi is preparing your next move — check back soon.",
    emptyTitleWaiting: "Loading strategy",
    emptyBodyWaiting: "Preparing your strategy details.",
    generatingHangTight: "Generating, hang on tight.",
    assessmentTabSummary: "Summary",
    assessmentTabFoundation: "Foundational",
    assessmentTabPerformance: "Business Reality Analysis",
    connect: {
      title: "Connect Meta and Google to unlock reports",
      why: "Zeqi needs access to your ads and analytics so we can guide your shop to success. Connect both accounts and we'll walk you through everything else.",
      body: "Tap the buttons below to link Meta and Google. Once both are connected, Zeqi will guide you through the rest.",
      verify: {
        heading: "After you connect",
        meta: "Zeqi confirms your Meta data stream automatically.",
        google: "You'll see your analytics synced inside Zeqi once connected.",
      },
      metaCta: "Connect Meta",
      metaConnected: "Connected",
      googleCta: "Connect Google",
      googleConnected: "Connected",
      productCostCta: "Add Product Costs",
      productCostConnected: "Product Costs Added",
      operatingCostCta: "Add Operating Costs",
      operatingCostConnected: "Operating Costs Added",
      checking: "Checking connections…",
      syncing:
        "Hang tight—we’re syncing your data now. This only takes a moment.",
    },
  },
  ProblemAndResult: {
    titleProblem: "The Problem",
    titleResearch: "Research",
    defaultProblem:
      "We’re reviewing your store’s current signals to generate the most likely root problem.",
    defaultResearch:
      "We’re compiling relevant research and benchmarks for your store. Check back soon.",
    viewSources: "View Sources",
    // (optional future)
    resultTitle: "Recommended Outcome",
  },
  ZeqiLoadingModal: {
    title: "Creating Your Zeqi Profile",
    subtitle:
      "This helps us figure out what’s wrong\nand fix it using our smart AI tools.",
    status: "Gathering Information From Shopify",
  },
  ZeqiMainTab: {
    assessment: "Assessment",
    strategy: "Strategy",
    keyFocus: "Execution",
    reports: "Reports",
    chat: "Chat",
  },
  ZeqiKeyFocusArea: {
    header: "Execution Areas",
    tabs: { suggested: "Suggested", running: "Running" },
    emptySuggested: "Generating actions, come back in a few.",
    emptyRunning: "Generating actions, come back in a few.",
    loadFailPrefix: "Failed to load:",
    tryAgain: "Try again",
  },
  HomePage: {
    assessmentMatrix: "Assessment",
    signInTitle: "Sign in to continue",
    signInPromptPrefix: "Use",
    signInPromptSuffix:
      "to feed Zeqi with your store and unlock the same dashboards as the mobile app.",
    loginCta: "Login",
    greeting: "Hey {{name}},",
    loadingShop: "Loading shop details...",
    ownerFallback: "Store",
  },
  ProductCostsScreen: {
    title: "Product Costs",
    subtitle:
      "Enter each product’s COGS. A cost of 0 is valid if that is the real cost, and margin insights stay less accurate until at least 70% of costs are filled.",
    productLabel: "Product Name",
    priceLabel: "Current Price",
    costLabel: "Product Cost",
    saving: "Saving...",
    updatePrice: "Update Price",
    updateCost: "Update Cost",
    empty: "No products available.",
    loading: "Loading products...",
    loadError: "Failed to load product costs.",
    updatePriceError: "Failed to update price.",
    updateCostError: "Failed to update product cost.",
    upload: "Upload Excel",
    uploading: "Uploading...",
    download: "Download Template",
    downloadFirst: "Download the template first, then upload.",
    uploadSuccess: "Updated {{updated}}, skipped {{skipped}}.",
    uploadFailed: "Upload failed.",
    searchPlaceholder: "Search products",
    refresh: "Refresh",
    missingPrice: "Enter a price before updating.",
    idLabel: "ID",
  },
  OperatingCostsScreen: {
    title: "Operating Costs",
    sub: "Track annual packaging, pick & pack, COD, and additional fees.",
    refresh: "Refresh",
    save: "Save",
    saving: "Saving...",
    labelRequired: "Label required",
    loading: "Loading operating costs...",
    loadError: "Failed to load operating costs.",
    saveError: "Failed to save operating costs.",
    addError: "Failed to add cost.",
    deleteError: "Failed to delete cost.",
    annualTitle: "Annual Operating Costs",
    additionalTitle: "Additional Annual Costs",
    packagingFee: "Packaging Fee",
    pickPackStorage: "Pick & Pack + Storage",
    codFee: "COD Fee",
    shippingFee: "Estimated Shipping Fee",
    gatewayPercent: "Payment Gateway %",
    gatewayFixed: "Payment Gateway Fixed Fee",
    total: "Total",
    labelPlaceholder: "Label",
    amountPlaceholder: "Amount",
    add: "Add",
    adding: "Adding...",
    remove: "Remove",
    emptyAdditional: "No additional costs yet.",
  },
  ReportsPage: {
    subtitle:
      "Access your latest strategy and performance reports. Tap to view details.",
    loading: "Loading reports...",
    loadErrorPrefix: "Failed to load reports:",
    ready: "Ready",
    tapToView: "Tap to view the report.",
    generating: "Generating. You will be notified.",
    explore: "Explore",
    reportDetails: "Report Details",
    labels: {
      benchmark: "Shop Summary",
      market: "Shop Market Analysis",
      competitor: "Shop Competitor Analysis",
      ideation: "Monthly Ideation Report",
      seo: "Shop SEO Report",
      adsAudit: "Ads Audit Report",
      influencer: "Influencer & Trending Report",
      meta: "Meta Ads Report",
      google_search_console: "Google Search Console",
      google_merchant_center: "Google Merchant Center",
      revenue_reality: "Revenue Reality Report",
      yearlyContent: "Monthly Events Calendar",
      target_audience: "Target Audience",
      historical_orders: "Historical Orders Report",
    },
    storeSnapshot: "Store Summary",
  },
  AppShell: {
    chatAriaLabel: "Open Zeqi chat",
    chatPlaceholder: "What's on your mind? Talk to me",
    sideRailHome: "Overview",
    sideRailAria: "Quick actions",
    rightRailAria: "Zeqi right rail",
    goHomeAria: "Go to overview",
    userSettings: "User Settings",
    collapseRail: "Collapse side rail",
    expandRail: "Expand side rail",
    openMenu: "Open menu",
    closeMenu: "Close menu",
    menuTitle: "Menu",
    notificationsTitle: "Notifications",
    toggleNotifications: "Toggle notifications",
    notificationFallback: "New update",
    notificationTimeFallback: "Just now",
    viewMore: "View More",
    noNotifications: "No new notifications.",
    chatTitle: "Zeqi Chat",
    chatOptions: "Chat options",
    newChat: "New chat with Zeqi",
    chatHistory: "Chat History",
    searchConversations: "Search conversations...",
    noConversationsYet: "No conversations yet",
    noConversationMatches: "No matching conversations",
    noPreview: "No messages yet",
    showMoreConversations: "Show more",
    collapseChat: "Collapse chat",
    expandChat: "Expand chat",
    collapseRightRail: "Collapse chat panel",
    expandRightRail: "Expand chat panel",
    chatMovedNotice: "Zeqi Chat is now available on the right panel.",
  },
  TypeLabels: {
    SUPER_AGENT: "Super Agent",
    STRATEGY: "Strategy",
    PLANNING: "Planning",
    ANALYTICS_INSIGHTS: "Analytics & Insights",
    ADVERTISING: "Advertising",
    CRM_EMAIL: "CRM & Email",
    ORGANIC_SOCIAL: "Organic Social",
    WEB_CRO: "Web CRO",
    SEO: "SEO",
    PRODUCT_INTEL: "Product Intel",
    INFLUENCER: "Influencer",
  },
  SuggestedScreen: {
    focusAreaFallback: "Focus Area",
    actionsInFocusArea_one: "{{count}} action in this focus area",
    actionsInFocusArea_other: "{{count}} actions in this focus area",
  },
  SuggestedActionSection: {
    actionsHeader: "Actions",
    counts: "{{s}} Suggested • {{r}} Running", // still only shows suggested + running
    runningBadge: "Running",
    completedBadge: "Completed", // 🔥 NEW
    checkDetails: "Check Details",
    emptySuggested: "No suggested actions yet.",
    emptyRunning: "No running or completed actions yet.", // clarified
    untitled: "Untitled",
  },
  SelectedSuggestedActionModal: {
    actionFallback: "Action",
    defaultExpectedResult: "Run these steps to drive the outcome. 🔧",
    actionPrefix: "Action:",
    discuss: "Discuss",
    runningNow: "Running…",
    runThisTask: "Run This Task",
    noTasks: "No Tasks",
    untitled: "Untitled",
  },
  SelectedRunningActionModal: {
    runningBadge: "Running",
    completedBadge: "Completed",
    discuss: "Discuss",
    defaultExpectedResult:
      "Execute these steps to optimize performance and keep momentum.",
    untitled: "Untitled",
  },
  SelectedSuggestedActionSection: {
    // dates / due
    noDueDate: "No due date",
    invalidDate: "Invalid date",
    overdue: "Overdue ({{days}}d)",
    dueToday: "Due Today",
    dueInDays: "Due in {{days}}d",
    dueOnDate: "Due {{date}}",

    // chips
    aiTask: "AI Task",
    userTask: "{{who}} Task",
    user: "User",
    runAll: "Run All Tasks",

    // header & fallback
    expectedResultTitle: "Expected Result",
    expectedResultFallback:
      "Execute this action to move the metric we care about.",
    tasks_one: "{{count}} Task",
    tasks_other: "{{count}} Tasks",
    untitledTask: "Untitled Task",

    // buttons & states
    completed: "Completed",
    running: "In Progress",
    markAsDone: "Mark as Done",
    cannotComplete: "Cannot complete",
    needsApproval: "Needs approval",
    aiOwnedTask: "AI-owned task",

    // alerts
    notAllowedTitle: "Not allowed",
    notAllowedMsg: 'Only tasks assigned to "User" can be completed.',
    notApprovedTitle: "Not approved",
    notApprovedMsg: "This task must be approved before completion.",
    completeErrorTitle: "Unable to complete task",
    unknownError: "Unknown error",

    // skip
    skipConfirmTitle: "Are you sure you want to ignore this task and skip it?",
    skipConfirmMessage: "",
    skipReasonPrompt: "Please tell us why you're ignoring this task.",
    skipReasonPlaceholder: "Enter your reason...",
    skipReasonRequired: "A reason is required to ignore this task.",
    skip: "Ignore Task",
    skipped: "Ignored",
  },
  ZeqiChatModal: {
    title: "Zeqi Chat",
    placeholder: "Write your message...",
    noAction: "No action found. Try opening chat from an Action card.",
    startConversation: "Start a conversation with Zeqi...",
    untitledTask: "Untitled Task",
    defaultRunPrompt: "Run this task.",
    defaultDiscussPrompt: "Let's discuss this task.",
  },
  TextInputTaskModal: {
    // headers
    tasks: "Tasks",
    running: "Running",
    otherTasks: "Other Tasks",

    // empties
    noRunning: "No tasks are running right now.",
    noOther: "No other tasks at the moment.",

    // chips / status
    automatedAI: "Automated (AI)",
    assignedToUser: "Assigned to User",
    suggested: "Suggested",
    completed: "Completed",
    runningEllipsis: "Running…",
    runThisTask: "Run This Task",
    discuss: "Discuss",
    // due labels
    noDueDate: "No due date",
    invalidDate: "Invalid date",
    overdue: "Overdue ({{days}}d)",
    dueToday: "Due today",
    dueTomorrow: "Due tomorrow",
    dueInDays: "Due in {{days}}d",

    // misc
    untitledTask: "Untitled Task",
  },
  GoogleConnectScreen: {
    headerTitle: "Google Connect",
    title: "Connect your Google Account",
    // NEW: clarify the two flows
    subtitleDual:
      "Link Google to power two workflows:\n• Google Findability (GA4 + GSC visibility)\n• Click Attraction (CTR diagnostics, schema & title hooks).",
    connectFindability: "Connect Google",
    connectingFindability: "Connecting…",
    connectClickAttraction: "Connect — Click Attraction",
    connectingClick: "Connecting to Click Attraction…",

    // existing:
    connect: "Connect with Google",
    subtitle:
      "Link Google Analytics (GA4) to pull traffic & conversion insights for your store.",
    connecting: "Connecting…",
    fetchingProps: "Fetching GA4 properties…",
    tip: "Make sure your GA4 property is installed on your storefront and receiving data for the most accurate insights.",
    oauthUserMissing: "User is not loaded yet.",
    checkingConnection: "Checking connection...",
    oauthError: "Could not complete Google OAuth.",
    authMissing: "Missing JWT. Please re-login.",
    noPropsTitle: "No GA4 Properties",
    noPropsBody:
      "We couldn't find any GA4 properties for your Google account.\n\nMake sure:\n• You're using a GA4 (not UA) property\n• You have at least Viewer permission on that property",

    // NEW (used when auto-triggering the report)
    creatingInitialEngagement: "Creating Initial Engagement…",
    initialEngagementReady: "Initial Engagement report generated.",
    connected: "Google Connected",
  },

  MetaConnectScreen: {
    headerTitle: "Meta Connect",
    title: "Connect Your Meta Business Account",
    subtitle:
      "For the best experience, make sure your Meta Pixel and Instagram account are connected to the same Meta Business account before continuing.",
    // kept for backward compatibility:
    connect: "Connect with Meta",

    // NEW:
    connectFacebook: "Connect with Meta",
    connectInstagram: "Connect Instagram",
    tip: "Verify your Meta Business Manager is active, you have the required permissions, and that your Pixel and Instagram are claimed/connected under that Business.",
    oauthUserMissing: "User is not loaded yet.",
    connecting: "Connecting...",
    checkingConnection: "Checking connection...",
    oauthError: "Something went wrong during Facebook login.",
    errorTitle: "Error",
    connected: "Meta Connected",
  },
  ShopReportsScreen: {
    title: "Shop Reports",
    subtitle:
      "Access your latest strategy and performance reports. Refresh to regenerate when needed.",
    benchmark: "Shop Benchmark Report",
    market: "Shop Market Analysis",
    competitor: "Shop Competitor Analysis",
    ideation: "Monthly Ideation Report",
    seo: "Shop SEO Report",
    adsAudit: "Ads Audit Report",
    influencer: "Influencer & Trending Report",
    initialEngagement: "Initial Engagement Report",
    alignment: "Alignment With Intent Report",
    clickAttraction: "Click Attraction Report",
    brandRecall: "Brand Recall Report",
    lightEngagement: "Light Engagement Report",
    shopOrganicVisibility: "Shop Organic Visibility Report",
    open: "Open",
    refresh: "Refresh",
    itemHint: "Tap Open to view, Refresh to regenerate.",
  },
  SubscriptionPlanScreen: {
    title: "Subscription",
    yourPlan: "Your Plan",
    statusLabel: "Status",
    activeBadge: "Active",
    premiumTier: "Premium Tier",
    haveCode: "Have a code?",
    codeHelp: "Enter your activation or promo code below to apply a plan.",
    placeholder: "e.g., ZEQI-PREM-XXXX",
    apply: "Apply",
    applying: "Applying...",
    detected: "Detected plan",
    plans: "Plans",
    selected: "Selected",
    choose: "Choose",
    viewDetails: "View details",
    alreadyActive: "Already active",
    alreadyActiveMsg: "You’re already on this plan.",
    comingSoon: "Coming soon",
    invalid: "Invalid",
    invalidMsg: "Please enter a code.",
    notRecognized: "Not recognized",
    notRecognizedMsg: "This code is invalid or expired.",
    success: "Success",
    successMsg: "Code applied successfully.",
    failed: "Failed",
    failedMsg: "Could not apply code. Please try again.",
    checkoutFailedMsg: "Unable to start checkout. Please try again.",
    checkoutStartedTitle: "Checkout opened",
    checkoutStartedMsg:
      "Complete the payment in your browser. Your plan will update automatically once Stripe confirms the transaction.",
    genericSuccessMsg: "{{plan}} activated successfully.",
    notice: "Notice",
    unsupportedCode: "That code isn't supported yet. Please contact support.",
    authRequiredTitle: "Sign in required",
    authRequiredMsg:
      "Please connect your store or sign in before managing subscriptions.",
    cancelConfirmTitle: "Cancel subscription?",
    cancelConfirmMsg:
      "Are you sure you want to cancel your paid subscription? You'll keep access until the end of your current billing period.",
    keep: "Keep",
    cancelNow: "Cancel Now",
    cancelSuccess: "Subscription cancelled",
    cancelSuccessMsg:
      "Your subscription has been cancelled. You'll retain access until the end of your billing cycle.",
    cancelFailed: "Unable to cancel",
    cancelFailedMsg: "We couldn't cancel your subscription. Please try again.",
    planFree: "Free",
    planSmsa: "SMSA",
    planGeneral: "General",
    planPremium: "Premium",
    status: {
      ACTIVE: "Active",
      TRIALING: "Trialing",
      PAST_DUE: "Past due",
      UNPAID: "Unpaid",
      INCOMPLETE: "Incomplete",
      INCOMPLETE_EXPIRED: "Incomplete expired",
      CANCELED: "Canceled",
      PAUSED: "Paused",
    },
    planDetails: {
      modalTitle: "{{plan}} plan",
      close: "Close",
      priceLabel: "Price",
      billingLabel: "Billing",
      includesLabel: "What's included",
      bestForLabel: "Best for",
      notesLabel: "Good to know",
      free: {
        tagline: "Wire Zeqi’s foundation before you commit.",
        price: "Free trial",
        billing: "10-day trial. No card required.",
        includes: [
          "2 Zeqi Chat messages per day for quick questions.",
          "AI onboarding checklist covering crawl, feeds, and policies.",
          "Automated store assessment with prioritized actions.",
          "Daily Zeqi briefing with your next best move.",
        ],
        bestFor: [
          "Merchants connecting Zeqi for the first time.",
          "Teams validating store foundations before paid automation.",
        ],
        notes: [
          "After 10 days you can upgrade to General, or Premium whenever you're ready.",
        ],
      },
      smsa: {
        tagline:
          "Co-funded program with SMSA to jumpstart growth and logistics.",
        price: "$270/mo (covered by SMSA for 6 months)",
        billing:
          "Enter the promo code at checkout. You pay $0 for 6 months, then $270 monthly.",
        includes: [
          "All Premium automation triggers unlocked for 6 months.",
          "SMSA logistics readiness audit and partner concierge.",
          "Monthly strategy reviews with prioritized action routing.",
        ],
        bestFor: [
          "Brands shipping through SMSA that want a co-funded start.",
          "Teams needing logistics visibility plus growth automation.",
        ],
        notes: [
          "Use the promo code at checkout to activate the six-month coverage.",
          "After the promotional window, billing continues monthly at the Premium rate.",
        ],
      },
      general: {
        tagline: "Steady AI guidance without full execution.",
        price: "$27/mo",
        billing: "Billed monthly. Cancel anytime before the next cycle.",
        includes: [
          "5 Zeqi Chat messages per day to unblock strategy questions.",
          "Core strategy reports refreshed each month.",
          "Automation across Foundation and General action clusters.",
          "Email support with 48-hour response time.",
        ],
        bestFor: [
          "Stores ready for consistent AI guidance.",
          "Teams graduating from the free onboarding trial.",
        ],
        notes: [
          "Perfect for merchants who want Zeqi’s direction while keeping execution lightweight.",
        ],
      },
      premium: {
        tagline: "Full execution powered by Zeqi across every channel.",
        price: "Tiered pricing from $270/mo",
        billing:
          "Billed monthly. Pricing tier adjusts automatically based on active product count.",
        includes: [
          "Unlimited strategy refreshes and automation triggers across all clusters.",
          "Product intelligence, campaign, and retention playbooks.",
          "Priority support with a dedicated AI operator.",
        ],
        bestFor: [
          "Operators scaling SKUs, ads, and lifecycle programs rapidly.",
          "Teams who want Zeqi to execute acquisition, retention, and merchandising.",
        ],
        notes: [
          "Tier 1: $270/mo for up to 50 active products.",
          "Tier 2: $280/mo for up to 100 active products.",
          "Tier 3: $300/mo for up to 200 active products.",
          "Tier 4: $320/mo for more than 200 active products.",
        ],
      },
    },
  },

  ReportBugModal: {
    title: "Report a Bug",
    emailLabel: "Your Email",
    emailPlaceholder: "you@company.com",
    messageLabel: "Describe the bug",
    messagePlaceholder: "What happened? Any steps to reproduce?",
    send: "Send",
    sending: "Sending…",
    invalidEmail: "Please enter a valid email.",
    shortMsg: "Please add a few more details (min 5 characters).",
    toast:
      "Thanks for reporting! Our team will review and resolve this within 24–48 hours.",
  },

  RequestFeatureModal: {
    title: "Request a Feature",
    emailLabel: "Your Email",
    emailPlaceholder: "you@company.com",
    messageLabel: "What would you like us to build?",
    messagePlaceholder: "Describe the feature and why it helps…",
    send: "Send",
    sending: "Sending…",
    invalidEmail: "Please enter a valid email.",
    shortMsg: "Please add a few more details (min 5 characters).",
    toast:
      "Thanks! Our team will review your request and get back to you within 24–48 hours.",
  },

  RequestIntegrationModal: {
    title: "Request an Integration",
    emailLabel: "Your Email",
    emailPlaceholder: "you@company.com",
    messageLabel: "Which integration do you need?",
    messagePlaceholder:
      "Tell us which platform or tool you want Zeqi to support and how you plan to use it…",
    send: "Send",
    sending: "Sending…",
    invalidEmail: "Please enter a valid email.",
    shortMsg: "Please add a few more details (min 5 characters).",
    toast:
      "Thanks! Our team will review your integration request and get back to you within 24–48 hours.",
  },

  ContactSupportModal: {
    title: "Contact Zeqi Support",
    emailLabel: "Your Email",
    emailPlaceholder: "you@company.com",
    messageLabel: "How can we help?",
    messagePlaceholder: "Write your message…",
    send: "Send",
    sending: "Sending…",
    invalidEmail: "Please enter a valid email.",
    shortMsg: "Please add a few more details (min 5 characters).",
    toast:
      "Thanks! We’ll get back to you within 24–48 hours. A Zeqi agent will contact you at the email provided.",
  },

  AuthCallbackPage: {
    authenticating: "Authenticating...",
  },

  ChatPage: {
    invalidFileMsg: "Please select valid image or PDF files under 10MB.",
    signInRequired: "Please sign in to chat with Zeqi.",
    typeMessage: "Ask Zeqi anything...",
  },

  // Add more screens...
};
